import { createContext, useContext } from "react";

import { hexHtmlToString } from "@hsl/core/utils/hexHtmlToString";

const TranslationContext = createContext<Record<string, string>>({});

export const useAllTranslations = () => useContext(TranslationContext);

export const TranslationProvider = TranslationContext.Provider;

function useTranslation() {
    const translations = useContext(TranslationContext);

    const T = (str: string) => {
        if (translations[str]) {
            return {
                translated: true,
                result: hexHtmlToString(translations[str]!),
            };
        } else {
            return {
                translated: false,
                result: str,
            };
        }
    };

    return T;
}

export default useTranslation;

export const Translate = ({
    children,
    insert,
}: {
    children: string;
    insert?: React.ReactNode;
}) => {
    const T = useTranslation();

    const showTranslations = new URLSearchParams(window.location.search).has(
        "showTranslations",
    );

    const { translated, result } = T(children);

    let combined: React.ReactNode = result;

    if (insert && result.includes("{}")) {
        const [a, ...b] = result.split("{}");
        combined = (
            <>
                {a}
                {insert}
                {b.join("{}")}
            </>
        );
    }

    if (showTranslations) {
        if (translated) {
            return <span className="bg-green-500/20">{combined}</span>;
        } else {
            return <span className="bg-red-500/20">{combined}</span>;
        }
    }
    return combined;
};
